import { useSelector } from 'react-redux';

import { IApplicationState } from 'shared/types/redux';

export function useReduxSelector<Selected = unknown>(
  selector: (state: IApplicationState) => Selected,
  equalityFn?: (left: Selected, right: Selected) => boolean,
): Selected {
  return useSelector<IApplicationState, Selected>(selector, equalityFn);
}
